import { render } from "./showPopup.vue?vue&type=template&id=2442cc46"
import script from "./showPopup.vue?vue&type=script&lang=js"
export * from "./showPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__